import React, { ReactElement, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AddFiveMailbox from "components/apps/containerMailDomain/actions/AddFiveMailbox";
import DowngradeFromMailPro from "components/apps/containerMailDomain/actions/DowngradeFromMailPro";
import UpgradeToMailPro from "components/apps/containerMailDomain/actions/UpgrateToMailPro";
import IconSelector from "components/shared/images/IconSelector";

import { getMinMailboxNumber } from "redux/handlers/mailDomainContainerHandler";

import { getServerDetails } from "redux/selectors/serversSelector";

import { useAppDispatch } from "hooks/reduxHook";

import CheckServerSsl from "./actions/CheckServerSsl";
import ContainerMailList from "./sections/ContainerMailList";

const ContainerMailPage = (): ReactElement => {
 const dispatch = useAppDispatch();
 const intl = useIntl();

 const params = useParams<{ id: string; section: string }>();
 const server = useSelector(getServerDetails);

 const [totalMailboxes, setTotalMailboxes] = useState<number>(0);

 useEffect(() => {
  (async () => {
   setTotalMailboxes(await dispatch(getMinMailboxNumber(Number(params.id))));
  })();
 }, []);

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
   <Stack direction="row" alignItems="center" pb={2}>
    <IconSelector icon="DockerIcon" props={{ fontSize: "medium", color: "kxOrange" }} />
    <Typography fontSize={16} ml={1} variant="unboundedTitle">
     <FormattedMessage id="server.container" />
    </Typography>
   </Stack>
   {server.type !== "container-mail-pro" ? (
    <Stack spacing={2} textAlign="left" mb={1}>
     <Typography variant="subtitle2">
      <FormattedMessage id="container.maildomains.activeSyncDisabled" />
     </Typography>
     <Stack direction="row">
      <UpgradeToMailPro id={server.id || 0} />
     </Stack>
    </Stack>
   ) : (
    <Stack spacing={2} textAlign="left" mb={1}>
     <Stack direction="row" alignItems="center">
      <IconSelector icon="ActiveSyncIcon" />
      <Typography variant="subtitle2" fontWeight="bold">
       ActiveSync Enabled
      </Typography>
     </Stack>
     <Stack spacing={1}>
      <Typography variant="subtitle2">
       <FormattedMessage
        id="container.maildomains.mailProEnabledMessage"
        values={{
         br: <br />,
         price: (
          <strong>{intl.formatMessage({ id: "container.maildomains.mailProMailboxPrice" })}</strong>
         )
        }}
       />
      </Typography>
      <Stack direction="row" spacing={1}>
       <Typography variant="subtitle2" fontWeight="bold">
        <FormattedMessage id="container.maildomains.mailboxesAvailable" />
       </Typography>
       <Typography variant="subtitle2">{server.mail_pro_mailbox || 0}</Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
       <Typography variant="subtitle2" fontWeight="bold">
        <FormattedMessage id="container.maildomains.mailboxesTotal" />
       </Typography>
       <Typography variant="subtitle2">{totalMailboxes}</Typography>
      </Stack>
     </Stack>
     <Stack direction="row" spacing={2}>
      <AddFiveMailbox id={server.id || 0} />
      <DowngradeFromMailPro id={server.id || 0} />
     </Stack>
    </Stack>
   )}
   <Divider />
   {server.ssl_checked ? (
    <ContainerMailList id={parseInt(params?.id || "0")} />
   ) : (
    <CheckServerSsl id={server.id || 0} />
   )}
  </Paper>
 );
};

export default ContainerMailPage;
